import React from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faLock, faMessage } from '@fortawesome/pro-regular-svg-icons';
import Drawer from '../../Drawer/Drawer';
import Button from '../../UI/Button/Button';
import StoryReplyItem from './StoryReplyItem';
import { EPHEMERAL_STORY_REPLIES_KEY, fetchStoryReplies } from '../../../../api/public-voissa/ephemeralStories';
import './StoryReplies.scss';

/**
 * Réponses reçues sur sa story, ouvertes depuis la bulle de la colonne d'actions (cahier des charges
 * V2, visuel 1 bis) : « N réponses · Visibles uniquement par vous », par lots de 20.
 * Modale enregistrée dans modalTypes (src/index.js).
 */
const StoryRepliesModal = ({ storyId, ownerId, totalReplies = 0, handleClose }) => {
    const query = useInfiniteQuery(
        [EPHEMERAL_STORY_REPLIES_KEY, storyId],
        ({ pageParam }) => fetchStoryReplies(storyId, { dateIndex: pageParam }),
        { enabled: !!storyId, getNextPageParam: (last) => (last?.more ? last.lastDateIndex : undefined) }
    );
    const replies = (query.data?.pages || []).flatMap((page) => page?.data || []);
    const total = query.data?.pages?.[0]?.total ?? totalReplies;

    return (
        <Drawer open={true} small handleClose={handleClose} headContent={
            <div className="story-replies-head">
                <span className="story-replies-head-count"><FontAwesomeIcon icon={faMessage} /> {total} réponse{total > 1 ? 's' : ''}</span>
                <span className="story-replies-private"><FontAwesomeIcon icon={faLock} /> Visibles uniquement par vous</span>
            </div>
        }>
            <div className="story-replies-modal">
                {query.isLoading && <div className="story-replies-state">Chargement…</div>}
                {query.isError && <div className="story-replies-state">Impossible de charger les réponses pour le moment.</div>}
                {query.isSuccess && !replies.length && <div className="story-replies-state">Personne n’a encore répondu à cette story.</div>}
                <ul className="story-replies-list">
                    {replies.map((reply) => (
                        <StoryReplyItem key={reply._id} reply={reply} storyId={storyId} ownerId={ownerId} />
                    ))}
                </ul>
                {query.hasNextPage && (
                    <Button small className="story-replies-more" disabled={query.isFetchingNextPage} onClick={() => query.fetchNextPage()}>
                        Afficher plus de réponses <FontAwesomeIcon icon={faChevronDown} />
                    </Button>
                )}
            </div>
        </Drawer>
    );
};

export default StoryRepliesModal;
